
import React from 'react';

// Componente Header para OncoFHIR Prescribe
interface HeaderProps {
  scrolled: boolean;
}

const Header: React.FC<HeaderProps> = ({ scrolled }) => {
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToId = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (id === 'root') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`fixed top-[41px] left-0 w-full z-[100] transition-all duration-500 ${
      scrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-2.5' : 'bg-transparent py-6'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        {/* Logotipo en texto con colores corporativos según instrucciones visuales */}
        <button 
          onClick={scrollToId('root')} 
          className="flex items-baseline gap-1 transition-transform hover:scale-105 active:scale-95 bg-transparent border-none p-0 cursor-pointer select-none"
        >
          <span className="text-2xl md:text-3xl font-black tracking-tighter text-medical">Onco</span>
          <span className="text-2xl md:text-3xl font-black tracking-tighter text-fhir">FHIR</span>
          <span className="ml-1 text-sm md:text-base font-bold text-gray-400 italic">Prescribe</span>
        </button>

        <div className="hidden lg:flex items-center gap-10">
          <nav className="flex items-center space-x-8 text-[11px] font-bold uppercase tracking-[0.15em] text-gray-700">
            <button onClick={scrollToId('solucion')} className="hover:text-medical transition-colors bg-transparent border-none cursor-pointer uppercase font-bold tracking-[0.15em]">La Solución</button>
            <button onClick={scrollToId('terapias')} className="hover:text-medical transition-colors bg-transparent border-none cursor-pointer uppercase font-bold tracking-[0.15em]">Alcance</button>
            <button onClick={scrollToId('caracteristicas')} className="hover:text-medical transition-colors bg-transparent border-none cursor-pointer uppercase font-bold tracking-[0.15em]">Estándares</button>
          </nav>

          <button 
            onClick={scrollToContact}
            className="bg-fhir hover:bg-orange-600 text-white px-7 py-3 rounded-xl text-[11px] font-black transition-all shadow-lg shadow-fhir/25 uppercase tracking-widest border-none cursor-pointer transform hover:scale-105"
          >
            RESERVAR CUPO
          </button>
        </div>
        
        <button className="lg:hidden text-dark text-2xl bg-transparent border-none cursor-pointer">
          <i className="fas fa-bars"></i>
        </button>
      </div>
    </header>
  );
};

export default Header;
